import React from 'react';
import { LeafIcon, RefreshCcwIcon, ZapIcon, TargetIcon, StethoscopeIcon, HeartIcon } from 'lucide-react';
export const BenefitsSection = () => {
  return <section className="w-full bg-white py-16 md:py-24" id="benefits" data-id="element-20">
      <div className="container mx-auto px-4 md:px-6" data-id="element-21">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-indigo-900 mb-8" data-id="element-22">
          Why Thousands Choose Setu Sleep Restore for Better Sleep
        </h2>
        <div className="flex flex-col md:flex-row items-center justify-center mb-12" data-id="element-23">
          <img src="https://images.unsplash.com/photo-1531353826977-0941b4779a1c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80" alt="Person waking up refreshed" className="rounded-lg shadow-lg w-full md:w-1/2 h-64 object-cover" onError={e => {
          e.target.src = 'https://images.unsplash.com/photo-1484627147104-f5197bcd6651?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80';
        }} data-id="element-24" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-25">
          <div className="bg-indigo-50 rounded-lg p-6 flex flex-col items-start" data-id="element-26">
            <div className="bg-white rounded-full p-3 mb-4 shadow-sm" data-id="element-27">
              <LeafIcon className="h-6 w-6 text-green-600" data-id="element-28" />
            </div>
            <h3 className="text-xl font-bold text-indigo-900 mb-2" data-id="element-29">
              100% Natural
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-30">
              No synthetic chemicals or harsh sedatives. Just pure,
              plant-derived melatonin in convenient mint-flavored strips that
              work with your body's wisdom.
            </p>
            <div className="mt-auto w-full h-32 bg-green-50 rounded-lg flex items-center justify-center" data-id="element-31">
              <img src="https://images.unsplash.com/photo-1523480717984-24cba35ae1ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" alt="Natural plant ingredients" className="rounded-lg w-full h-32 object-cover" onError={e => {
              e.target.src = 'https://images.unsplash.com/photo-1585071550721-fdb362ae2b8d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80';
            }} data-id="element-32" />
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-6 flex flex-col items-start" data-id="element-33">
            <div className="bg-white rounded-full p-3 mb-4 shadow-sm" data-id="element-34">
              <RefreshCcwIcon className="h-6 w-6 text-indigo-600" data-id="element-35" />
            </div>
            <h3 className="text-xl font-bold text-indigo-900 mb-2" data-id="element-36">
              Non-Habit Forming
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-37">
              Use it when you need it, skip it when you don't. Your body won't
              become dependent or lose its ability to sleep naturally.
            </p>
            <div className="mt-auto w-full h-32 bg-indigo-50 rounded-lg flex items-center justify-center" data-id="element-38">
              <img src="https://images.unsplash.com/photo-1508739773434-c26b3d09e071?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" alt="Freedom from dependency" className="rounded-lg w-full h-32 object-cover" onError={e => {
              e.target.src = 'https://images.unsplash.com/photo-1500964757637-c85e8a162699?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1806&q=80';
            }} data-id="element-39" />
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-6 flex flex-col items-start" data-id="element-40">
            <div className="bg-white rounded-full p-3 mb-4 shadow-sm" data-id="element-41">
              <ZapIcon className="h-6 w-6 text-yellow-500" data-id="element-42" />
            </div>
            <h3 className="text-xl font-bold text-indigo-900 mb-2" data-id="element-43">
              Wake Up Energized
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-44">
              Experience the difference of real, restorative sleep. No more
              dragging yourself through morning brain fog.
            </p>
            <div className="mt-auto w-full h-32 bg-yellow-50 rounded-lg flex items-center justify-center" data-id="element-45">
              <img src="https://images.unsplash.com/photo-1484627147104-f5197bcd6651?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" alt="Energized morning routine" className="rounded-lg w-full h-32 object-cover" onError={e => {
              e.target.src = 'https://images.unsplash.com/photo-1519834785169-98be25ec3f84?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1528&q=80';
            }} data-id="element-46" />
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-6 flex flex-col items-start" data-id="element-47">
            <div className="bg-white rounded-full p-3 mb-4 shadow-sm" data-id="element-48">
              <TargetIcon className="h-6 w-6 text-red-500" data-id="element-49" />
            </div>
            <h3 className="text-xl font-bold text-indigo-900 mb-2" data-id="element-50">
              Precise Dosing
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-51">
              Each strip contains the optimal 5mg melatonin dose—enough to be
              effective, not so much that you feel drowsy the next day.
            </p>
            <div className="mt-auto w-full h-32 bg-red-50 rounded-lg flex items-center justify-center" data-id="element-52">
              <img src="https://images.unsplash.com/photo-1579165466741-7f35e4755183?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" alt="Precise measurement" className="rounded-lg w-full h-32 object-cover" onError={e => {
              e.target.src = 'https://images.unsplash.com/photo-1605496036006-fa36378ca4ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1674&q=80';
            }} data-id="element-53" />
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-6 flex flex-col items-start" data-id="element-54">
            <div className="bg-white rounded-full p-3 mb-4 shadow-sm" data-id="element-55">
              <StethoscopeIcon className="h-6 w-6 text-blue-600" data-id="element-56" />
            </div>
            <h3 className="text-xl font-bold text-indigo-900 mb-2" data-id="element-57">
              Doctor Recommended
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-58">
              Trusted by sleep specialists and healthcare professionals as a
              first-line approach to sleep issues and jet lag.
            </p>
            <div className="mt-auto w-full h-32 bg-blue-50 rounded-lg flex items-center justify-center" data-id="element-59">
              <img src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" alt="Healthcare professional" className="rounded-lg w-full h-32 object-cover" onError={e => {
              e.target.src = 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1964&q=80';
            }} data-id="element-60" />
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-6 flex flex-col items-start" data-id="element-61">
            <div className="bg-white rounded-full p-3 mb-4 shadow-sm" data-id="element-62">
              <HeartIcon className="h-6 w-6 text-pink-500" data-id="element-63" />
            </div>
            <h3 className="text-xl font-bold text-indigo-900 mb-2" data-id="element-64">
              Risk-Free
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-65">
              30-day money-back guarantee. If better sleep doesn't come
              naturally, we'll refund every rupee.
            </p>
            <div className="mt-auto w-full h-32 bg-pink-50 rounded-lg flex items-center justify-center" data-id="element-66">
              <img src="https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" alt="Satisfaction guarantee" className="rounded-lg w-full h-32 object-cover" onError={e => {
              e.target.src = 'https://images.unsplash.com/photo-1516383740770-fbcc5ccbece0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1674&q=80';
            }} data-id="element-67" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};